import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
    },
    contentBtn: {
        // position: 'absolute',
        // bottom: 60,
        marginTop: 10,
        paddingHorizontal: 25,
        width: '100%',        
        marginBottom: 10
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    contentBtnDelete: {
        // position: 're',
        // bottom: 30,
        marginTop: 10,
        paddingHorizontal: 25,
        width: '100%',
        marginBottom: 20
    },
    textBtnDelete: {
        color: '#BC1010',
        textAlign: 'center',
        textDecorationLine: 'underline',
        fontWeight: 'normal'
    },
    containerSocialContract: {
        paddingRight: 25,
        marginTop: 20
    },
    description: {
        textAlign: 'justify',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 15
    },
    btnAdd: {
        height: 40,
        width: '100%',
        borderColor: '#32BFB1',
        borderWidth: 2,
        borderRadius: 20,
        marginTop: 20
    },
    iconAdd: {
        textAlign: 'center',
        marginTop: 5
    },
    modalCenteredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 22,
        backgroundColor: "rgba(0,0,0,.6)",
    },
    closeModal: {
        marginLeft: "auto",
        marginRight: -10,
        marginTop: -5
    },
    modalView: {
        marginTop: 20,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        paddingHorizontal: 35,
        paddingVertical: 15,
        alignItems: "center",
        overflow: 'hidden',
        shadowOpacity: 0.2,
        shadowColor: '#000',
        shadowRadius: 0,
        shadowOffset: {
            width: 0,
            height: 0
        }
    },
    modalText: {
        width: "100%",
        backgroundColor: "#fff",
        marginVertical: 30,
        textAlign: "center",
        alignContent: "center",
    },
    button: {
        borderRadius: 10,
        padding: 10,
        marginTop: 25,
        outlineWidth: 0,
        borderWidth: 0,
        elevation: 2
    },
});

export default styles;
